// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { Auth } from 'aws-amplify';
import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import Column from '../../components/Column';
import Title from '../../components/typography/Title';
import MemberContext from '../../contexts/MemberContext';
import CommonContext from '../../contexts/CommonContext';
import Avatar, { S as AvatarS } from '../../components/Avatar';
import { FormattedMessage } from 'react-intl'

import Popup from '../../components/Popup';

const S = {
  Popup: styled(Popup)`
    width: 190px;
    white-space: nowrap;
    text-align: center;
  `,
  Avatar: styled(Avatar)`
    margin: 22px auto 0;
    width: 80px;
    height: 80px;
    border: none;

    ${AvatarS.Title} {
      font-size: 37px;
      line-height: 45px;
      letter-spacing: 0.59px;
    }
  `,
  Title: styled.h1`
    margin-top: 13px;
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #434343;
  `,
  Credit: styled.p`
    margin-top: 4px;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #EF8200;
  `,
  List: styled.ul`
    margin-top: 11px;
    display: flex;
    flex-direction: column;


    > li:last-child {
      margin-top: 6px;
    }
  `,
  Item: styled.li`
    padding: 9px 7px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #666666;
    cursor: pointer;

    &:hover {
      background-color: rgba(201, 201, 201, 0.3);
    }
  `,
}

interface MemberPopupProps extends React.ComponentPropsWithRef<'div'> {
  closePopup: () => void;
}

const MemberPopup: React.FC<MemberPopupProps> = ({ closePopup, ...props }) => {
  const member = useContext(MemberContext);
  const common = useContext(CommonContext);
  const history = useHistory();

  async function handleLogout() {
    const username = await Auth.currentAuthenticatedUser()
      .then(
        (user) => user.signInUserSession.idToken.payload['cognito:username']
      )
      .catch(() => null);
    console.log('handleLogout-username:', username)
    const cognitoKey = localStorage.getItem('CognitoKey')
    const idToken = localStorage.getItem(`${cognitoKey}.IdToken`)
    if (
      username &&
      username.indexOf('facebook') === -1 &&
      username.indexOf('google') === -1 ||
      idToken
    ) {
      await Auth.signOut();
      await member.clear();
      await common.clear();
      member.removeCognito();
    }
    history.push('/login');
  }

  return (
    <S.Popup {...props}>
      <Column>
        <S.Avatar style={{ backgroundImage: `url(${member.imageUrl})` }}>
          {
            !member.imageUrl || member.imageUrl === ''
              ? <Title style={{ textTransform: 'uppercase', fontFamily: 'Noto Sans TC', fontStyle: 'normal', color: '#FFFFFF' }}>{member.firstName ? member.email[0].toUpperCase() : ''}</Title>
              : null
          }
        </S.Avatar>
        <S.Title>{member.username}</S.Title>
        <S.Credit>
          <FormattedMessage
            id="credit"
            values={{ credit: member.organizationCredit || 0 }}
          />
        </S.Credit>
        <S.List>
          <S.Item as={Link} to="/member" onClick={closePopup}><FormattedMessage id="G010" /></S.Item>
          <S.Item onClick={handleLogout}><FormattedMessage id="G012" /></S.Item>
        </S.List>
      </Column>
    </S.Popup>
  );
}

export { MemberPopup as default };
